import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

// Retrieve apiKey from environment variable
const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;

// Firebase configuration
const firebaseConfig = {
  apiKey: apiKey,
  authDomain: "chat-magic-752a8.firebaseapp.com",
  projectId: "chat-magic-752a8",
  storageBucket: "chat-magic-752a8.appspot.com",
  messagingSenderId: "384802000917",
  appId: "1:384802000917:web:a196d269153ec1fb503e1c",
  measurementId: "G-ELYWZ1HQ5V"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
